import classNames from 'classnames';
import forEach from 'lodash/forEach';
import map from 'lodash/map';
import moment from 'moment';
import React from 'react';
import DatePicker from 'react-datepicker';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import swal from 'sweetalert2';
import {
  getJerseyShop,
  updateJerseyShop,
} from '../../../actions/entities/jerseys';
import Loader from '../../../components/Loader';
import {getParameterByName} from '../../../helpers/location';
import './index.css';

class JerseysPreview extends React.Component {
  state = {
    selected: getParameterByName('lang', window.location.href) || 'fr-FR',
    scheduledShop: null,
    prodShop: null,
    previewDate: null,
  };

  componentDidMount() {
    this.getBothShop();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.selected !== this.state.selected) {
      this.getBothShop();
    }
  }

  getBothShop(previewDate) {
    const {dispatch} = this.props;
    if (previewDate) {
      dispatch(
        getJerseyShop(
          {language: this.state.selected, useTemp: false, previewDate},
          this.onSuccess,
          this.onError,
          this.onRequest,
        ),
      );
      dispatch(
        getJerseyShop(
          {language: this.state.selected, useTemp: true, previewDate},
          this.onSuccess,
          this.onError,
          this.onRequest,
        ),
      );
    } else {
      dispatch(
        getJerseyShop(
          {language: this.state.selected, useTemp: false},
          this.onSuccess,
          this.onError,
          this.onRequest,
        ),
      );
      dispatch(
        getJerseyShop(
          {language: this.state.selected, useTemp: true},
          this.onSuccess,
          this.onError,
          this.onRequest,
        ),
      );
    }
  }

  onSuccess = (response, useTemp) => {
    this.setState({[!useTemp ? 'prodShop' : 'scheduledShop']: response});
  };

  onRequest = useTemp => {
    this.setState({[!useTemp ? 'prodShop' : 'scheduledShop']: null});
  };

  toggleLang(selected) {
    this.setState({selected});
  }

  renderJerseyList(idList, jerseys) {
    const list = [];

    forEach(idList, (id, i) => {
      const {tagText, tagColor} = jerseys[id];
      list.push(
        <div key={i} className="jerseyItem">
          <div className="image">
            <img
              className="img"
              src={`${jerseys[id].imageUrl}?nocache=${new Date()}`}
              alt=""
            />
          </div>
          {tagText && (
            <div className="tag" style={{backgroundColor: tagColor}}>
              {tagText}
            </div>
          )}
        </div>,
      );
    });
    return list.map(li => li);
  }

  renderCollections(collectionsList, jerseysList) {
    return map(collectionsList, (c, index) => {
      return (
        <div key={index} className="collectionContainer">
          <div>
            <div className="dotted">{c.name}</div>
            <div className="jerseyList">
              {this.renderJerseyList(c.jerseysIds, jerseysList)}
            </div>
          </div>
        </div>
      );
    });
  }

  onError = error => {
    swal({
      title: `Oops...`,
      type: 'error',
      html:
        `Something went wrong:<br/>${error}<br/>` +
        `<pre><code>${JSON.stringify(error, undefined, 4)}</code></pre>`,
    });
  };

  onClickUpdateButton = () => {
    const {dispatch} = this.props;
    const {selected} = this.state;
    swal({
      title: 'Are you sure ?',
      type: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
    })
      .then(() => {
        dispatch(updateJerseyShop({language: selected}, null, this.onError));
      })
      .catch(error => {
        console.log(error);
      });
  };

  render() {
    const {selected, scheduledShop, prodShop, previewDate} = this.state;
    return (
      <div id="JerseysListPreview">
        <div className="lang text-center">
          <Link
            to={`/jerseys/preview?lang=fr-FR`}
            className={classNames('btn btn-box-tool', {
              selected: selected === 'fr-FR',
            })}
            onClick={() => this.toggleLang('fr-FR')}>
            <span className="flag-icon flag-icon-fr" />
          </Link>
          <Link
            to={`/jerseys/preview?lang=en-GB`}
            className={classNames('btn btn-box-tool', {
              selected: selected === 'en-GB',
            })}
            onClick={() => this.toggleLang('en-GB')}>
            <span className="flag-icon flag-icon-gb" />
          </Link>
          <Link
            to={`/jerseys/preview?lang=es-ES`}
            className={classNames('btn btn-box-tool', {
              selected: selected === 'es-ES',
            })}
            onClick={() => this.toggleLang('es-ES')}>
            <span className="flag-icon flag-icon-es" />
          </Link>
        </div>
        <div className="text-center">
          <Link
            to={`/jerseys/collections?lang=${selected}`}
            className="btn btn-default m-3">
            Back
          </Link>
          <button
            className="btn m-3 btn-danger"
            onClick={this.onClickUpdateButton}>
            Update
          </button>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          className="m-3">
          <div>
            <DatePicker
              className="inputDatePicker"
              selected={(previewDate && new Date(previewDate)) || null}
              onChange={date =>
                this.setState({previewDate: moment(date).utc().format()})
              }
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              dateFormat="dd/MM/yyyy HH:mm"
              timeCaption="time"
              placeholderText="Select Date"
            />
          </div>
          <div className="m-2">
            <button
              disabled={!previewDate}
              className="btn btn-success"
              onClick={() => this.getBothShop(previewDate)}>
              OK
            </button>
          </div>
        </div>
        <section className="content">
          <div className="row">
            <div className="row">
              <div className="col-md-6">
                <div className="box box-default">
                  <div
                    style={{minHeight: !prodShop && '110px'}}
                    className="box-header with-border text-center">
                    <h3 className="box-title">In production</h3>
                  </div>
                  {prodShop ? (
                    this.renderCollections(
                      prodShop.collections,
                      prodShop.jerseys,
                    )
                  ) : (
                    <Loader />
                  )}
                </div>
              </div>
              <div className="col-md-6">
                <div className="box box-default">
                  <div
                    style={{minHeight: !scheduledShop && '110px'}}
                    className="box-header with-border text-center">
                    <h3 className="box-title">Scheduled</h3>
                  </div>
                  {scheduledShop ? (
                    this.renderCollections(
                      scheduledShop.collections,
                      scheduledShop.jerseys,
                    )
                  ) : (
                    <Loader />
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default connect(
  state => ({
    collectionsList: state.app.jerseys.collections.data,
    jerseysList: state.app.jerseys.list.data,
  }),
  dispatch => ({dispatch}),
)(JerseysPreview);



// WEBPACK FOOTER //
// ./src/pages/Jerseys/Preview/index.js